import { AxiosResponse, InternalAxiosRequestConfig } from './types'
import { ElMessage } from 'element-plus'
import qs from 'qs'
import { SUCCESS_CODE, TRANSFORM_REQUEST_DATA } from '@/constants'
import { useUserStoreWithOut } from '@/store/modules/user'
import { objToFormData } from '@/utils'

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (
    config.method === 'post' &&
    config.headers['Content-Type'] === 'application/x-www-form-urlencoded'
  ) {
    config.data = qs.stringify(config.data)
  } else if (
    TRANSFORM_REQUEST_DATA &&
    config.method === 'post' &&
    config.headers['Content-Type'] === 'multipart/form-data' &&
    !(config.data instanceof FormData)
  ) {
    config.data = objToFormData(config.data)
  }
  if (config.method === 'get' && config.params) {
    const query = qs.stringify(config.params, { arrayFormat: 'repeat', skipNulls: true })
    config.params = {}
    if (query) {
      config.url = `${config.url}?${query}`
    }
  }
  return config
}

const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === 'blob') {
    return response
  } else if (response.data.code === SUCCESS_CODE) {
    return response.data
  } else {
    if (response?.data?.code !== 401) {
      ElMessage.error(response?.data?.msg)
    }
    if (response?.data?.code === 401) {
      defaultUnauthorized()
    }
    return Promise.reject(new Error(response?.data?.msg))
  }
}

//默认未授权处理
const defaultUnauthorized = () => {
  const userStore = useUserStoreWithOut()
  userStore.logout()
}

export { defaultResponseInterceptors, defaultRequestInterceptors, defaultUnauthorized }
